<template>
  <div class="modern">
    <el-breadcrumb class="breadcrumb">
      <el-breadcrumb-item>
        <span class="breadcrumb_span changeFont" @click="backHome">市场风控</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <span class="changeFont">{{ infoMation.name }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-skeleton v-if="loading" :rows="15" animated/>
    <div v-else class="container">
      <div class="container_box">
        <div class="solidLine"></div>
        <div class="newsType">
          <img :src="require('@/assets/recycling/news/Rectangle.svg')" alt=""/>
          <span class="newsType_name">{{ infoMation.name }}</span>
          <img class="newsType_img" :src="require('@/assets/recycling/news/Rectangle.svg')" alt=""/>
        </div>
        <div class="solidLine"></div>
      </div>
      <div class="newsCard" v-for="(item, index) in choseTypeData.records" :key="item.id">
        <div class="newsCard_content">
          <div class="right">
            <div class="newsName">
              <li
                @click="lookNews({breadList: [infoMation.name, item.title], newsId: item.id, parentId: item.columnIds})"
                :title="item.title"
                class="newsName_first"
              >
                {{ item.title }}
              </li>
              <span class="newsName_last">{{ item.source }}</span>
              <span class="newsName_last">{{ item.gmtCreated }}</span>
            </div>
          </div>
        </div>
        <div
          v-if="isDivisibleBy5(index + 1) && index + 1 !== choseTypeData.records.length"
          style="padding: 0 40px"
        >
          <div class="dottedLine"></div>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[20, 30, 40, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { scrollTop } from '@/util/scrollTop';
import { getPunishmentPage } from '@/API/news/news';

export default {
  name: 'newsInfo',
  data() {
    return {
      total: 0,
      pageNum: 1,
      pageSize: 20,
      choseTypeData: {},
      baseUrl: process.env.VUE_APP_BASE_URL,
      infoMation: {},
      loading: false,
    };
  },
  props: {
    choseNewTypeInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    choseNewTypeInfo: {
      deep: true,
      immediate: true,
      handler: function (val) {
        this.infoMation = val;
        this.getlist(val);
      },
    },
  },
  mounted() {
    scrollTop();
  },
  methods: {
    isDivisibleBy5(number) {
      return number % 5 === 0;
    },
    getlist(item) {
      this.loading = true;
      let parmrs = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        type: 'finance',
      };
      getPunishmentPage(item.id, parmrs)
        .then((res) => {
          if (res.code === 200) {
            this.choseTypeData = res.data;
            this.total = res.data.total;
            this.pageNum = res.data.current;
            this.pageSize = res.data.pageSize;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    backHome() {
      this.$emit('goBack', '');
    },
    lookNews(obj) {
      this.$emit('lookMyEyes', obj);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getlist(this.infoMation);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getlist(this.infoMation);
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 768px) {
  .changeFont {
    font-size: 16px !important;
  }

  .newsType {
    font-size: 14px !important;
    font-weight: 600 !important;
  }

  .newsName {
    .newsName_first {
      font-size: 14px !important;
      line-height: 24px !important;
      height: 24px !important;
    }

    .newsName_last {
      font-size: 14px !important;
      height: 24px !important;
      line-height: 24px !important;
    }
  }

  .pagination {
    justify-content: center !important;
  }

  /deep/ .el-pagination__total {
    display: none !important;
  }

  /deep/ .el-pagination__sizes {
    display: none !important;
  }

  .modern {
    min-height: unset !important;
  }
}

.modern {
  background-color: #f8fafc;
  min-height: 100vh;
  margin-bottom: 60px;
  font-family: "仿宋", "仿宋_GB2312", "FangSong", serif;

  .breadcrumb {
    margin: 30px 0 30px 0;
  }

  .container {
    .container_box {
      display: flex;
      width: 100%;
      align-items: center;
    }

    .newsType {
      width: auto;
      white-space: nowrap;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 24px;
      font-weight: 700;
      margin: 25px 0;

      .newsType_img {
        transform: rotate(180deg);
      }

      .newsType_name {
        margin: 0 12px;
      }
    }

    .solidLine {
      flex: 1;
      margin: 0 20px;
      border-bottom: 1px solid #999999;
      align-self: center;
    }

    .dottedLine {
      margin: 20px 0;
      width: 100%;
      border-bottom: 1px dashed #999999;
    }

    .newsCard {
      width: 100%;
      margin-bottom: 20px;

      .newsCard_content {
        width: 100%;
        height: 100%;
        display: flex;
        padding: 0 20px;

        .right {
          width: 100%;
          height: 100%;
          margin: 0 20px;

          .newsName {
            display: flex;
            width: 100%;
            justify-content: space-between;
            margin-bottom: 12px;

            .newsName_first {
              font-size: 20px;
              line-height: 24px;
              height: 24px;
              width: 75%;
              color: #333333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              cursor: pointer;
            }

            .newsName_first::marker {
              color: rgba(143, 143, 143, 0.76);
            }

            .newsName_first:hover {
              color: #1da1f2;
            }

            .newsName_last {
              display: flex;
              justify-content: end;
              width: 25%;
              font-size: 18px;
              line-height: 22px;
              color: #999999;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .newsText {
            height: 22px;
            margin-bottom: 16px;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
          }

          .newsText,
          .newsInfo {
            font-size: 14px;
            line-height: 22px;
            color: #788295;
          }

          .newsInfo:hover {
            color: #1da1f2;
          }
        }
      }
    }
  }
}

.breadcrumb_span {
  color: #000000;
  font-weight: 500;
  cursor: pointer;
}

.changeFont {
  font-size: 16px;
}

.pagination {
  display: flex;
  justify-content: end;
  margin-top: 30px;
}
</style>
